<template>
	<div style="overflow: auto;height: 100%;margin-left: 0px;margin-right: 0px;">
		<!-- 模板内容不变 -->
		<div style="margin-bottom: 22px;display: flex;align-items: center;padding:0 16px;">
			<div style="flex: 1;display: flex;align-items: center;">
				<div style="font-size: 14px;color: #0F1A3A;  opacity: 0.5;">{{ $t('driver.驾驶评分统计') }}</div>
				<img :src="require('@/assets/images/ic_arrow_right.png')" style="width: 24px;height: 24px;" />
				<div style="font-size: 14px;color: #0F1A3A;">{{ $t('driver.驾驶评分统计详情') }}</div>
			</div>
			<el-button type="primary" @click="onClose" size="small">{{ $t('driver.返回') }}</el-button>
		</div>
		<el-row :gutter="20" style="margin-left:0;margin-right: 0;">
			<el-col :span="7">
				<div style="border: 1px solid #D9E4F8;background: #FFFFFF;border-radius: 2px;display: flex;flex-direction: column;">
				  <!-- 原有标题和total组件 -->
				  <div style="padding: 20px;font-size: 14px;font-weight: bold;color: #0E193B;">{{carNo}}</div>
				  <mileage_item_total :score="totalScore" :mileage="totalMileage" :time="totalTime" />
				  
				  <!-- 列表区域（限制高度+滚动） -->
				  <div style="flex: 1;overflow-y: auto;padding: 0 16px;">
				    <div v-for="(item, idx) in currentPageData" :key="idx">
				      <mileage_item_info 
				        :score="item.Score" 
				        :mileage="item.Mileage"
				        :time="formatTime(item.BeginTime)+ ' - ' + formatTime(item.EndTime)"
				        @click="handleItemClick(item)" 
				      />
				    </div>
				    <div v-if="dataTypes.length === 0" style="text-align: center;padding: 20px;color: #999;">
				      {{ $t('public.noData') }}
				    </div>
				  </div>
				  
				  <!-- 分页区域（独立容器，强制宽度100%） -->
				 <div class="pagination-wrapper">
				   <!-- <div>共{{dataTypes.length}}条</div> -->
				   <el-pagination 
				     @size-change="handleSizeChange" 
				     @current-change="handleCurrentChange"
				     :current-page="currentPage" 
				     :page-sizes="pageSizes" 
				     :page-size="pageSize"
				    layout="prev, pager, next" 
				     :total="dataTypes.length" 
				     size="small"
				   />
				 </div>
				</div>
			</el-col>
			<el-col :span="17">
				<div style="background: #FFFFFF;border-radius: 2px;border: 1px solid #D9E4F8;">
					<mileage_info :traceData="localTraceData" :drivingScore="localDrivingScore"
						:drivingdata="localDrivingdata" />
					<score_item_list style="margin:16px;" :drivingScore="localDrivingScore" />
					<div style="width: 100%;height: 400px;">
						<KingLongMap ref="klmap" :coordsType="9" />
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<script>
	import mileage_info from "./components/mileage_info"
	import score_item_list from "./components/score_item_list"
	import mileage_item_info from "./components/mileage_item_info"
	import mileage_item_total from "./components/mileage_item_total"
	import {
		mapState
	} from 'vuex';
	import KingLongMap from "@/components/KingLongMap";

	export default {
		props: {
			carNo: String,
			dataTypes: {
				type: Array,
				default: () => []
			},
			totalMileage: Number,
			totalScore: Number,
			totalTime: String,
			traceData: {
				type: Array,
				default: () => []
			},
			drivingScore: {
				type: Array,
				default: () => []
			},
			drivingdata: {
				type: Object,
				default: () => ({
					Consume: 0.0,
					Duration: 0.0,
					Speed: 0.0,
					Mileage: 0.0
				})
			}
		},
		components: {
			mileage_info,
			score_item_list,
			mileage_item_info,
			KingLongMap,
			mileage_item_total
		},
		data() {
			return {
				GpsData: [],
				dataTypesTemp: this.dataTypes,
				loading: false,
				hasDefaultClicked: false, // 标记是否已执行过默认点击
				localTraceData: Array.isArray(this.traceData) ? [...this.traceData] : [],
				localDrivingScore: Array.isArray(this.drivingScore) ? [...this.drivingScore] : [], // 核心修复1
				localDrivingdata: {
					...this.drivingdata
				},
				currentPage: 1, // 当前页码
				pageSize: 10, // 每页条数（默认10条）
				pageSizes: [10,20],
			}
		},
		computed: {
			...mapState({
				operator: state => state.user.operator,
				vehicles: state => state.app.vehicles,

			}),
			currentPageData() {
				const start = (this.currentPage - 1) * this.pageSize;
				const end = start + this.pageSize;
				return this.dataTypes.slice(start, end);
			}
		},
		// 关键修改：监听dataTypes变化，数据就绪后触发默认点击
		watch: {
			// 监听 dataTypes 变化（数据就绪触发）
			dataTypes: {
				handler(newVal) {
					console.log('dataTypes变化:', newVal);
					// 数据有效 + 未触发过默认点击 → 执行
					if (newVal && newVal.length > 0 && !this.hasDefaultClicked) {
						this.$nextTick(() => {
							console.log('通过watch触发默认点击第一个项');
							this.handleItemClick(newVal[0]);
							this.hasDefaultClicked = true;
						});
					}
				},
				deep: true,
				immediate: true // 初始执行一次，覆盖数据提前就绪场景
			},
			// 单独监听 props 变化（同步到本地数据）
			traceData(newVal) {
				this.localTraceData = Array.isArray(newVal) ? [...newVal] : [];
			},
			drivingScore(newVal) {
				this.localDrivingScore = Array.isArray(newVal) ? [...newVal] : [];
			},
			drivingdata(newVal) {
				this.localDrivingdata = {
					...newVal
				};
			},
			// 额外监听 carNo 变化（切换车辆时重置并重新触发）
			carNo(newCarNo, oldCarNo) {
				if (newCarNo && newCarNo !== oldCarNo) {
					console.log('切换车辆，重置默认点击状态');
					this.hasDefaultClicked = false; // 重置标记
					// 延迟 300ms 确保 dataTypes 同步更新后触发
					setTimeout(() => {
						if (this.dataTypes && this.dataTypes.length > 0 && !this.hasDefaultClicked) {
							this.handleItemClick(this.dataTypes[0]);
							this.hasDefaultClicked = true;
						}
					}, 300);
				}
			}
		},
		methods: {
			onClose() {
				this.$emit('onClose');
			},
			handleItemClick(item) {
				if (this.loading) return;
				this.loading = true;
				console.log('点击的列表项数据:', item);
				const mileage = item.Mileage;
				this.getTrackData(item);
				this.$api.queryWebDrivingScoreDetail({
					OperatorID: this.operator.OperatorId.toString() || '',
					VehicleIDs: item.VehicleIDs.toString() || '',
					BeginTime: item.BeginTime,
					EndTime: item.EndTime,
				}).then(res => {
					this.loading = false;
					if (res.code === 200) {
						console.log('详情接口返回:', res)
						this.localTraceData = Array.isArray(res.TraceData) ? res.TraceData : [];
						this.localDrivingScore = Array.isArray(res.DrivingScore) ? res.DrivingScore : [];
						this.localDrivingdata = {
							Consume: res.Consume || 0.0,
							Duration: res.Duration || 0.0,
							Speed: res.Speed || 0.0,
							Mileage: mileage
						};
					} else {
						this.$message.warning(res.message || '数据获取失败');
					}
				}).catch(err => {
					this.loading = false;
					this.$message.error('接口请求失败');
					console.error('查询错误：', err);
				});
			},
			// 其他方法不变...
			// initMap() {
			// 	var polyline = [{
			// 			lng: 116.31871013851249,
			// 			lat: 39.872531471741304
			// 		},
			// 		{
			// 			lng: 116.47798176490944,
			// 			lat: 39.92572926658523
			// 		},
			// 		{
			// 			lng: 116.49009773808255,
			// 			lat: 39.88965118665674
			// 		},
			// 	];
			// 	this.$refs.klmap.addPolyline("s_line", "s_line", polyline, 8, '#18a45b', true);
			// },
			getTrackData(item) {
				this.$api.QueryVehicleTrackInfo({
					VehicleId: item.VehicleIDs.toString() || '',
					StartTime: item.BeginTime,
					EndTime: item.EndTime,
					Flag: 2,
					ParkDuration: 1,
					LanguageId: 1

				}).then((res) => {
					if (res.code === 200 && res.data && res.data.GpsData && res.data.GpsData.length > 0) {
						this.GpsData = res.data.GpsData;
						this.$nextTick(this.initGpsData);
					} else {
						this.$message.warning(this.$t("vehicletrack.nonTrackTip"));
					}
				}).catch(() => {
					this.$message.warning(this.$t("vehicletrack.nonTrackTip"));
				});
			},
			initGpsData() {
				var bd_gps = [];
				this.GpsData.forEach((item) => {
					bd_gps.push({
						lng: item.Longitude,
						lat: item.Latitude
					});
				});
				this.$refs.klmap.addPolyline("gps_line", "gps_line", bd_gps, 5, "#2A7AFF");
			},
			formatTime(timeStr) {
				if (!timeStr) return '';
				return timeStr.replace('T', ' ').replace('Z', '').replace(/-/g, '/');
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.currentPage = 1; // 切换每页条数时重置为第1页
			},
			// 新增：当前页码变化时触发
			handleCurrentChange(val) {
				this.currentPage = val;
			},
		},
		mounted() {
			this.$nextTick(() => {
				if (this.dataTypes && this.dataTypes.length > 0 && !this.hasDefaultClicked) {
					console.log('通过mounted触发默认点击第一个项');
					this.handleItemClick(this.dataTypes[0]);
					this.hasDefaultClicked = true;
				} else {
					console.log('mounted时dataTypes还未准备好:', this.dataTypes);
				}
			});
		}
	}
</script>
<style lang="scss" scoped>
	::v-deep .el-pagination {
	  width: 100% !important;
	  display: flex;
	  align-items: center;
	  justify-content: flex-end; /* 页码区域右对齐 */
	}
	
	/* 调整分页元素间距，避免拥挤 */
	::v-deep .el-pagination__sizes {
	  margin-right: 16px !important;
	}
	::v-deep .el-pagination__pager {
	  margin: 0 !important; /* 清除默认margin，避免溢出 */
	}
	::v-deep .el-pagination__button {
	  min-width: 28px !important; /* 缩小页码按钮宽度 */
	  height: 28px !important;
	  line-height: 28px !important;
	}
	@media (max-width: 768px) {
	  ::v-deep .el-pagination__total {
	    display: none;
	  }
	}
	.pagination-wrapper {
	  overflow-x: auto;
	  display: flex;
	  align-items: center;
	  padding: 12px 0;
	}
</style>